import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language-service.service';

@Component({
  selector: 'app-nav-tabs',
  templateUrl: './nav-tabs.component.html',
  styleUrls: ['./nav-tabs.component.scss']
})
export class NavTabsComponent implements OnInit {
  @Input() currentApp!:any;
  titleSectionProp: any = {
    class: 'text-center iq-title-box-2',
    title: 'SYNC_MANAGER',
  };
  constructor(
    public translate: TranslateService,
    public route:ActivatedRoute,
    public langService:LanguageService
  ) { }

  ngOnInit(): void {
  }

  makeActive(navList:any, nav:any){
    navList.forEach((elem:any)=>{
      elem.active = ""
    })
    nav.active = 'active'
  }
}
